export default function WaveAnimatio() {
    return (
        <div className="absolute inset-0">
            <div className="absolute bottom-0 left-0 w-full h-96 overflow-hidden">
                <svg className="absolute bottom-0 w-full h-full" viewBox="0 0 1440 320" preserveAspectRatio="none">
                    <path
                        fill="#1665f6"
                        fillOpacity="0.12"
                        d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L0,320Z"
                    >
                        <animate
                            attributeName="d"
                            values="
                  M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L0,320Z;
                  M0,64L48,90C96,116,192,149,288,160C384,171,480,149,576,128C672,107,768,86,864,90C960,94,1056,128,1152,144C1248,160,1344,160,1392,160L1440,160L1440,320L0,320Z;
                  M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L0,320Z
                "
                            dur="22s"
                            repeatCount="indefinite"
                        />
                    </path>
                </svg>
            </div>
        </div>
    );
}